var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 31,
    fill: "white",
    stroke: "#03CDEF",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7100_54789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 30.5C44.235 30.5 46.305 31.205 48 32.39V26C48 24.335 46.665 23 45 23H39V20C39 18.335 37.665 17 36 17H30C28.335 17 27 18.335 27 20V23H21C19.335 23 18.015 24.335 18.015 26L18 42.5C18 44.165 19.335 45.5 21 45.5H32.52C31.875 44.135 31.5 42.62 31.5 41C31.5 35.195 36.195 30.5 42 30.5ZM30 20H36V23H30V20Z",
    fill: "#00BAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 33.5C37.86 33.5 34.5 36.86 34.5 41C34.5 45.14 37.86 48.5 42 48.5C46.14 48.5 49.5 45.14 49.5 41C49.5 36.86 46.14 33.5 42 33.5ZM44.475 44.525L41.25 41.3V36.5H42.75V40.685L45.525 43.46L44.475 44.525Z",
    fill: "#00BAE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7100_54789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHistoryIcon);
export default __webpack_public_path__ + "static/media/WorkHistoryIcon.80444fda6064aed4fd07ad3657cadea5.svg";
export { ForwardRef as ReactComponent };